import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_OioColumn = _resolveComponent("OioColumn")!
  const _component_OioTable = _resolveComponent("OioTable")!
  const _component_OioModal = _resolveComponent("OioModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_oio_input, {
      value: _ctx.value,
      "onUpdate:value": _ctx.change,
      onFocus: _ctx.focus,
      onBlur: _ctx.blur,
      onPressEnter: _withModifiers(_ctx.onEnter, ["stop","prevent"]),
      onKeyup: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["stop","prevent"]), ["enter","native"])),
      placeholder: "请输入69码"
    }, null, 8, ["value", "onUpdate:value", "onFocus", "onBlur", "onPressEnter"]),
    _createVNode(_component_OioModal, {
      visible: _ctx.showDialog,
      title: "选择商品",
      "onUpdate:visible": _ctx.changeVisble
    }, {
      default: _withCtx(() => [
        _createVNode(_component_OioTable, {
          size: _ctx.TableSize.small,
          showOverflow: "",
          showHeaderOverflow: "",
          border: "",
          resizable: "",
          data: _ctx.tableData,
          scrollX: { gt: -1 },
          scrollY: { gt: -1 },
          tooltipConfig: { enterable: true },
          height: "300px",
          columnConfig: { useKey: true },
          sortConfig: { remote: true },
          editConfig: {
        trigger: 'click',
        mode: 'cell',
        autoClear: true,
        showIcon: true
      },
          onEditActived: _ctx.editActived,
          onEditClosed: _ctx.editClosed
        }, {
          default: _withCtx(() => [
            _createVNode(_component_OioColumn, {
              type: "checkbox",
              width: "42",
              fixed: "left"
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
              return (_openBlock(), _createBlock(_component_OioColumn, {
                key: index,
                label: column.label,
                width: column.width,
                minWidth: column.minWidth,
                fixed: column.fixed == null || column.fixed === false ? undefined : column.fixed,
                field: column.itemData,
                "class-name": `table-column-${column.itemData}`,
                "header-class-name": `table-header-${column.itemData}`,
                renderDefaultSlot: column.renderDefaultSlot
              }, null, 8, ["label", "width", "minWidth", "fixed", "field", "class-name", "header-class-name", "renderDefaultSlot"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["size", "data", "onEditActived", "onEditClosed"])
      ]),
      _: 1
    }, 8, ["visible", "onUpdate:visible"])
  ], 64))
}